import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Project page components
import FormField from "components/Form/FormField";
import { useEffect, useState } from "react";
import { RequestService } from "services/RequestService";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

function AddForm({ formData }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const {
    name,
    description,
    startedDate,
    endedDate,
    progress,
    clientId,
    projectStatus,
    categoryId,
    changeRequestCount,
    companyId,
  } = formField;

  const {
    name: nameV,
    description: descriptionV,
    clientId: clientIdV,
    startedDate: startedDateV,
    endedDate: endedDateV,
    projectStatus: projectStatusV,
    categoryId: categoryIdV,
    progress: progressV,
    changeRequestCount: changeRequestCountV,
    companyId: companyIdV,
  } = values;
  const [companies, setCompanies] = useState([]);
  const [categories, setCategories] = useState([]);
  const [clients, setClients] = useState([]);
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [budgetStatuses, setBudgetStatuses] = useState([]);

  const getAllCompanies = async () => {
    let options = [];
    await RequestService.get("/companies/dropdown").then((response) => {
      if (response.status === 200 && response.data.data !== null) {

        response.data.data.map((company) => {
          options.push({
            value: company.id,
            label: company.name,
          });
        });
      }
    });
    setCompanies(options);
  };
  const getAllCategories = async () => {
    let options = [];
    await RequestService.get("/Category").then((response) => {
      if (response.status === 200 && response.data.data !== null) {
        response.data.data.map((category) => {
          options.push({
            value: category.id,
            label: category.name,
          });
        });
      }
    });
    setCategories(options);
  };
  const getAllClients = async () => {
    let options = [];
    await RequestService.get("/Client").then((response) => {
      if (response.status === 200 && response.data.data !== null) {
        response.data.data.map((client) => {
          options.push({
            value: client.id,
            label: client.name,
          });
        });
      }
    });
    setClients(options);
  };
  const getAllProjectStatuses = async () => {
    let options = [];
    await RequestService.get("/Project/ProjectStatusList").then((response) => {
      if (response.status === 200 && response.data.data !== null) {
        let js = response.data.data;
        Object.entries(js).forEach(([key, value]) => {
          options.push({
            value: value,
            label: key,
          });
        });
      }
    });
    setProjectStatuses(options);
  };
  const getAllBudgetStatuses = async () => {
    let options = [];
    await RequestService.get("/budget-statuses/dropdown").then((response) => {
      if (response.status === 200 && response.data.data !== null) {
        response.data.data.map((budgetStatus) => {
          options.push({
            value: budgetStatus.id,
            label: budgetStatus.name,
          });
        });
      }
    });
    setBudgetStatuses(options);
  };

  useEffect(() => {
    getAllCompanies();
    getAllClients();
    getAllCategories();
    getAllProjectStatuses();
  }, []);
  const isOptionEqualToValue = (option, value) => option.id === value.id;

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">المعلومات الرئيسية للمشروع</MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              variant="outlined"
              type={name.type}
              label={name.label}
              name={name.name}
              value={nameV}
              placeholder={name.placeholder}
              error={errors.name && touched.name}
              success={nameV.length > 0 && !errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
          <FormField
              label={description.label}
              name={description.name}
              value={descriptionV}
              placeholder={description.placeholder}
              error={errors.description && touched.description}
              success={descriptionV.length > 0 && !errors.description}
              multiline
              rows={5}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormField
              type={startedDate.type}
              label={startedDate.label}
              name={startedDate.name}
              value={startedDateV}
              placeholder={startedDate.placeholder}
              error={errors.startedDate && touched.startedDate}
              success={startedDateV.length > 0 && !errors.startedDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={endedDate.type}
              label={endedDate.label}
              name={endedDate.name}
              value={endedDateV}
              placeholder={endedDate.placeholder}
              error={errors.endedDate && touched.endedDate}
              success={endedDateV.length > 0 && !errors.endedDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              variant="outlined"
              options={clients}
              isOptionEqualToValue={isOptionEqualToValue}
              renderInput={(params) => (
                <FormField
                  {...params}
                  variant="outlined"
                  label={clientId.label}
                  value={clientId}
                  name={clientId.name}
                  placeholder={clientId.placeholder}
                />
              )}
              onChange={(e, v) => {
                setFieldValue("clientId", v.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={projectStatuses}
              isOptionEqualToValue={isOptionEqualToValue}
              renderInput={(params) => (
                <FormField
                  {...params}
                  variant="standard"
                  label={projectStatus.label}
                  value={projectStatus}
                  name={projectStatus.name}
                  placeholder={projectStatus.placeholder}
                />
              )}
              onChange={(e, v) => {
                setFieldValue("projectStatus", v.value);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={categories}
              isOptionEqualToValue={isOptionEqualToValue}
              renderInput={(params) => (
                <FormField
                  {...params}
                  variant="standard"
                  label={categoryId.label}
                  value={categoryId}
                  name={categoryId.name}
                  placeholder={categoryId.placeholder}
                />
              )}
              onChange={(e, v) => {
                setFieldValue("categoryId", v.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={companies}
              isOptionEqualToValue={isOptionEqualToValue}
              renderInput={(params) => (
                <FormField
                  {...params}
                  variant="standard"
                  label={companyId.label}
                  value={companyId}
                  name={companyId.name}
                  placeholder={companyId.placeholder}
                />
              )}
              onChange={(e, v) => {
                setFieldValue("companyId", v.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={progress.type}
              label={progress.label}
              name={progress.name}
              value={progressV}
              placeholder={progress.placeholder}
              error={errors.progress && touched.progress}
              success={progressV >= 0 && progressV <= 100 && !errors.progress}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={changeRequestCount.type}
              label={changeRequestCount.label}
              name={changeRequestCount.name}
              value={changeRequestCountV}
              placeholder={changeRequestCount.placeholder}
              error={errors.changeRequestCount && touched.changeRequestCount}
              success={changeRequestCountV >= 0 && !errors.changeRequestCount}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

AddForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default AddForm;
